import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { partTypeTire } from "../../../../constants/partTypes";
import { useLanguage } from "../../../../i18n/useLanguage";
import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { Image } from "../../../../ui/Image/Image";
import { fixTireImageUrl } from "../../../../util/fixTireImageUrl";
import { getPartFallbackSrc } from "../../../../util/getPartFallbackSrc";
import { getPartName } from "../../../../util/getPartName";
import { getTiresizeAndClass } from "../../../../util/getTireClassAndSize";
import { getTirePartNumber } from "../../../Tires/Common/getTirePartNumber";
import { PartPrice } from "./PartPrice";

export const ComboTileTire: FunctionComponent<{
  onClick?: VoidFunction;
  part: TirePartItem;
  quantity: number;
}> = ({ onClick, part, quantity }) => {
  const [language] = useLanguage();

  return (
    <div
      className={clsx("combo__tile md:combo__tile--md lg:combo__tile--lg")}
      id={`combo-${part.partDetails.primaryPart.itemId}`}
      onClick={onClick}
    >
      <h3>{getPartName(part, language)}</h3>
      <div className="combo__tile_info">
        <div className="combo__tile_texts">
          <p>
            {getTiresizeAndClass(part as TirePartItem, false)},{" "}
            {part?.partDetails.primaryPart.tireLoadRating}/
            {part?.partDetails.primaryPart.tireSpeedIndex}/
            {part?.partDetails.primaryPart.tirePlyRating}
          </p>
          <p className="combo__tile_sub">{getTirePartNumber(part)}</p>
          <p className="combo__tile_price pb-2">
            <PartPrice part={part} quantity={quantity} />
          </p>
          <div>
            <img
              alt="Manufacturer logo"
              className="h-4"
              src={part.partDetails.primaryPart.tireManufacturerImage}
            />
          </div>
        </div>
        <div>
          <Image
            alt="product image"
            className="combo__tile_image"
            errorClassName="opacity-60 blur-[16px]"
            fallbackSrc={getPartFallbackSrc(partTypeTire)}
            src={fixTireImageUrl(part.partDetails.primaryPart.tireImageLink)}
          />
        </div>
      </div>
    </div>
  );
};
